import React from 'react';
import afterImg from '../../assets/img/about/after.png';

const AboutUs4 = () => {
    return (
        <section className="about-us4-section">
            <div className="about-us4-container">
                <div className="about-us4-content">
                    <h2 className="title">
                        More Than 10 Years We Provide <span className="text-secondary">Architecture Solutions Service For You</span>
                    </h2>
                    <p className="desc">
                        We are the sub division of Chudasama Outsourcing Pvt. Ltd. 
                        Established in the year 2008, and we have been certified as 
                        India's top 500 startups companies. We are a Team of 100+ 
                        architectures, engineers, technicians, BIM Modelers and 
                        draftsmen. We are expertise in architectural, construction and 
                        industrial outsourcing, project management and have worked 
                        with more than 2000 clients globally.
                    </p>
                </div>
                
                <div className="about-us4-gallery">
                    <div className="main-image-wrapper">
                        <img src={afterImg.src || afterImg} alt="Architecture Solution" className="about-us4-img-main" />
                    </div>
                    <div className="side-images-wrapper">
                        <img src={afterImg.src || afterImg} alt="BIM Detail" className="about-us4-img-side img-top" />
                        <img src={afterImg.src || afterImg} alt="Engineering Detail" className="about-us4-img-side img-bottom" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutUs4;
